// Shared "PUR-06" / "INV-01" / "ADJ-12" style formatting for the sequential
// document numbers (purchaseNumber, invoiceNumber, stockAdjustmentNumber).
// Display-only - the underlying stored value stays a bare number (it's used
// as a lookup key elsewhere, e.g. stock transactions are linked by
// purchaseNumber), so this never touches what's saved, only how it's shown.
export const DOC_PREFIXES = {
  invoice: "INV",
  purchase: "PUR",
  stockAdjustment: "ADJ",
};

// Zero-pads a purely numeric value to at least 2 digits ("6" -> "06", "123"
// stays "123"); anything non-numeric (a legacy free-text number, or already
// "PUR-06") is passed through as-is so this is safe to call defensively.
export function formatDocNumber(prefix, value) {
  const raw = String(value ?? "").trim();
  if (!raw) return "";
  if (!/^\d+$/.test(raw)) return raw;
  return `${prefix}-${raw.padStart(2, "0")}`;
}

export const formatInvoiceNumber = (value) => formatDocNumber(DOC_PREFIXES.invoice, value);
export const formatPurchaseNumber = (value) => formatDocNumber(DOC_PREFIXES.purchase, value);
export const formatStockAdjustmentNumber = (value) => formatDocNumber(DOC_PREFIXES.stockAdjustment, value);
